import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-termos-uso',
  standalone: true,
  imports: [],
  templateUrl: './termos-uso.component.html',
  styleUrl: './termos-uso.component.scss'
})
export class TermosUsoComponent {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router
  ) { }


  ngOnInit(): void {
    
    if (isPlatformBrowser(this.platformId)) {
      this.checkMobile();
      if (typeof window !== 'undefined') {
        window.addEventListener('resize', this.checkMobile.bind(this));
      }

      // 🔹 Garante que o scroll acontece depois da renderização
      setTimeout(() => {
        window.scrollTo(0, 0);
      });

      // 🔹 Faz o scroll ao navegar entre páginas
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          setTimeout(() => {
            window.scrollTo(0, 0);
          });
        }
      });
    }
  }

  mobile: boolean = false
  checkMobile() {
    if (typeof window !== 'undefined'){
      this.mobile = window.innerWidth < 935;
    }
  }
}
